module.exports = __webpack_public_path__ + "img/themes.3019c7d3.svg";